
import { defineComponent, inject } from 'vue'
import AccountSvg from '@/components/svgs/AccountSvg.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'

export default defineComponent({
  name: 'AccountDropdownMenu',
  components: {
    AccountSvg
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    return {
      miscellaneousService
    }
  },
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    collapseDropdown(): void {
      this.isExpanded = false
    },
    logout(): void {
      this.miscellaneousService.logoutUser().then(() => {
        this.collapseDropdown()
        this.$router.push('/')
      })
    },
    toggleDropdown(): void {
      this.isExpanded = !this.isExpanded
    }
  }
})
